import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { debounce } from 'lodash';
export const TOP_MENU_HEIGHT = 120;
export const MENU_PADDING = 30;
export const DEBOUNCE_TIME = 300;
const withWindowScroll = (Component) => {
    var _a;
    return hoistNonReactStatics((_a = class extends React.PureComponent {
            constructor() {
                super(...arguments);
                this.state = {
                    menuContainerStyle: {},
                    height: 'auto',
                    dropup: false,
                    width: 0,
                    maxHeight: 0,
                };
                this.controlRef = null;
                this.scrollHandler = null;
                this.bodyHandler = null;
                this.setScrollHandler = handler => {
                    this.scrollHandler = handler;
                };
                this.setBodyClickHandler = (handler, controlRef) => {
                    this.bodyHandler = handler;
                    this.controlRef = controlRef;
                    document.addEventListener('click', this.handleBodyClick);
                };
                this.resetBodyClickHandler = () => {
                    this.bodyHandler = null;
                    this.controlRef = null;
                    document.removeEventListener('click', this.handleBodyClick);
                };
                this.handleScroll = e => {
                    if (this.scrollHandler) {
                        this.scrollHandler(e);
                    }
                };
                this.handleBodyClick = e => {
                    if (this.controlRef &&
                        this.bodyHandler &&
                        !this.controlRef.contains(e.target)) {
                        this.bodyHandler(e);
                    }
                };
                this.calculateFixedBound = ({ setHeight, hasSearch, controlRef, style }) => {
                    const { dropup } = this.state;
                    if (!controlRef || !window) {
                        return;
                    }
                    const button = controlRef.getBoundingClientRect();
                    const { width, height, left, top, bottom } = button;
                    const toTop = top;
                    const toBottom = window.innerHeight - bottom;
                    const menuContainerStyle = {
                        ...style,
                        left: `${left}px`,
                        width: `${width}px`,
                        top: dropup ? undefined : `${bottom}px`,
                        bottom: dropup
                            ? `${window.innerHeight - (height > top ? height : top)}px`
                            : undefined,
                    };
                    this.setState(({ maxHeight }) => {
                        if (setHeight) {
                            maxHeight =
                                Math.max(toTop, toBottom) - MENU_PADDING - TOP_MENU_HEIGHT;
                            if (hasSearch) {
                                // reduce size to one field with padding
                                maxHeight -= height + MENU_PADDING;
                            }
                        }
                        return { menuContainerStyle, maxHeight, width };
                    });
                };
                this.calculateDropup = controlRef => {
                    if (!controlRef || !window) {
                        return;
                    }
                    const rect = controlRef.getBoundingClientRect();
                    const { top, height } = rect;
                    const toBottom = window.innerHeight - top - height;
                    this.setState(() => ({
                        dropup: top > toBottom,
                    }));
                };
                this.calculateDropupDebounced = debounce(this.calculateDropup, DEBOUNCE_TIME);
            }
            componentDidMount() {
                window.addEventListener('resize', this.handleScroll);
                window.addEventListener('scroll', this.handleScroll, true);
            }
            componentWillUnmount() {
                window.removeEventListener('resize', this.handleScroll);
                window.removeEventListener('scroll', this.handleScroll, true);
                this.resetBodyClickHandler();
                this.calculateDropupDebounced.cancel();
            }
            render() {
                return (<Component {...this.props} {...this.state} calculateDropup={this.calculateDropup} calculateDropupDebounced={this.calculateDropupDebounced} calculateFixedBound={this.calculateFixedBound} resetBodyClickHandler={this.resetBodyClickHandler} setBodyClickHandler={this.setBodyClickHandler} setScrollHandler={this.setScrollHandler}/>);
            }
        },
        _a.displayName = `withWindowScroll(${Component.displayName || Component.name})`,
        _a), Component);
};
export default withWindowScroll;
